import {
  Button,
  Div,
  H3,
  Img,
  Modal,
  noAvailability,
  P,
  PropsModal,
} from '@vgrubs/components';
import { AvailabilityComponent } from './AvailabilityComponent';
import { MenuAvailabilityV2Response } from 'components/src/types/menu.types';
import { MenuV2Response } from 'components/src/types/menu.types';
import { Dispatch, SetStateAction } from 'react';

export const AddAvailabilityModal = ({
  addAvailabilityModal,
  closeModal,
  availability,
  setAvailability,
  menu,
}: PropsModal & {
  addAvailabilityModal: boolean;
  menu: MenuV2Response | null;
  availability: MenuAvailabilityV2Response[];
  setAvailability: Dispatch<SetStateAction<MenuAvailabilityV2Response[]>>;
}) => {
  return (
    <Modal
      isOpen={addAvailabilityModal}
      closeModal={closeModal}
      header="Add Availability"
      logo={false}
      zIndex={100}
      footer={
        <Button $selected $w="100%" $mb="16" onClick={() => closeModal?.()}>
          Confirm
        </Button>
      }
      width="400px"
      $numOfFloatingButtons={1}
    >
      <Div $flex $column $gap="24px">
        <div>
          {menu?.availability?.map((item, i) => (
            <AvailabilityComponent
              item={item}
              key={i}
              setAvailability={setAvailability}
              availability={availability}
              edit
            />
          ))}
          {menu?.availability && menu?.availability?.length < 1 && (
            <Div $flex $column $alignCenter>
              <Img alt="" $width="180px" src={noAvailability} $mb="24" />
              <H3 $mb="12" $center>
                No Availability
              </H3>
              <P $mb="24" $center>
                This menu currently has no availability schedules.
              </P>
            </Div>
          )}
        </div>
      </Div>
    </Modal>
  );
};
